import React from 'react'
import { findDOMNode } from 'react-dom'
import { DropTarget, DragSource } from 'react-dnd'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const types = {
  Card: 'card',
  Drag: 'drag'
}

@DragSource(types.Card, {
  beginDrag(props, monitor, component) {
    // 返回需要注入的属性
    return {
      id: props.id
    }
  },
  endDrag(props, monitor, component) {
    // 拖拽完成更新外部form
  }
}, (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
})
@DropTarget(types.Card, {
  drop(props, monitor, component) {
    //
  },
  hover(props, monitor, component) {
    if (!component) return null

    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex == hoverIndex) return

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    const clientOffset = monitor.getClientOffset()

    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }
    props.moveCard(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  }
}, (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }
})
class SortList extends React.Component {
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      children
    } = this.props

    const opacity = isDragging ? 0 : 1

    return connectDragSource(
      connectDropTarget(
        <div className='cmdb-form-card'>
          <div className={opacity ? '' : 'card-dragging'}>
            {opacity ? children : '・'}
          </div>
        </div>
      )
    )
  }
}

export default props => (
  <DndProvider backend={HTML5Backend}><SortList {...props} /></DndProvider>
)
